import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import axios from '../../helpers/Axios'

export const getAddsRecordedData = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<object> => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/api/rpmweb/sensors/recorded/${patientKey}/${startTime}/${endTime}?timezone=${clientTimeZone}`,

    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const getAddsManualData = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<object> => {
  return axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/api/rpmweb/adds/manual/${patientKey}/${startTime}/${endTime}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}
